// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"274":"Home","804":"DiscardedItems","810":"NotFound","867":"Settings"}[chunkId] + "." + {"274":"e98cd7dc","804":"e5c6748d","810":"e98cd7dc","867":"e9966120"}[chunkId] + ".css";
};